import React from "react";
import { KeySquare } from "lucide-react";
import { isFeatureActive } from "../../../utils/secretCodes";

const WordGameButton = ({ onClick }) => {
  const isGameUnlocked = isFeatureActive("STOCK_WORDLE_GAME");

  if (!isGameUnlocked) return null;

  return (
    <button
      onClick={onClick}
      className="game-trigger-button word-game-button"
      title="Play StockWordle"
    >
      <KeySquare size={20} />
    </button>
  );
};

export default WordGameButton;
